import React, { useEffect, useState } from 'react';
import useHttp from '../../../../../hooks/use-http';
import toast from 'react-hot-toast';
import Inputs from './components/Inputs';
import GridProvider from './components/GridProvider';
import MuiDialog from '../../../../UI/MuiDialog/MuiDialog';
import { useTranslation } from 'react-i18next';
import { handleErrorMessage } from '../../../../../../shared/api/handleErrorMessage';
import Spinner from '../../../../UI/Modal/Spinner';

const Ciklusi = ({ idMasine }) => {
  const INITIAL_VALUES = {
    id: 0,
    brojCiklusa: '',
    datum: new Date(),
  };
  const { t, i18n } = useTranslation();
  const { getData, isLoading } = useHttp('');
  const { getData: vratiPodatkeGet, isLoading: loadingPodaci } = useHttp('');
  const [gridData, setGridData] = useState([]);
  const [formValues, setFormValues] = useState(INITIAL_VALUES);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const vratiPodatke = async () => {
    const config = {
      url: 'Masine/masineCiklusi_pregled',
      method: 'POST',
      data: {
        idMasine: idMasine,
      },
    };
    const result = await vratiPodatkeGet(config);

    if (result.length > 0) {
      setGridData(result);
    } else {
      setGridData([]);
    }
  };
  useEffect(() => {
    vratiPodatke();
  }, []);
  const handleSaveData = async () => {
    const config = {
      method: 'POST',
      url: 'Masine/masineCiklusi_IU',
      data: {
        id: formValues.id,
        idMasine: idMasine,
        datum: formValues.datum,
        brojCiklusa: +formValues.brojCiklusa,
        idKorProm: +localStorage.idKorisnika,
      },
    };
    const result = await getData(config);
    if (result.rezultat > 0) {
      vratiPodatke();
      setFormValues(INITIAL_VALUES);

      toast.success(t('dataAddedSuccessfully'));
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  const handleEditData = async (item) => {
    setFormValues(item);
  };
  const handleCloseDelete = () => {
    setFormValues(INITIAL_VALUES);
    setOpenDeleteDialog(false);
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: 'Masine/masineCiklusi_D',
      data: { id: formValues.id },
    };
    const response = await getData(config);
    if (response > 0) {
      toast.success(t('messages.dataSuccessfullyDeleted'));
      setFormValues(INITIAL_VALUES);
      setOpenDeleteDialog(false);
      vratiPodatke();
      return;
    }
    toast.error(handleErrorMessage(response));
  };
  const handleOpenDeleteDialog = (id) => {
    setFormValues((curr) => {
      return { ...curr, id: id };
    });
    setOpenDeleteDialog(true);
  };
  return (
    <div>
      {isLoading && <Spinner />}
      <Inputs
        formValues={formValues}
        setFormValues={setFormValues}
        handleSave={handleSaveData}
      />{' '}
      <GridProvider
        data={gridData}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
        handleEditData={handleEditData}
        loading={loadingPodaci}
      />{' '}
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={handleCloseDelete}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default Ciklusi;
